"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const RenderRadioField = (props) => {
    const { field: { name }, onValueChange, text, value, defaultChecked, textStyle, ...otherProps } = props;
    return (react_1.default.createElement(core_1.Box, { style: { display: 'flex', alignItems: 'center' } },
        react_1.default.createElement(core_1.Radio, { value: value, checked: defaultChecked, onChange: onValueChange, name: name, color: "primary", ...otherProps }),
        react_1.default.createElement(core_1.Typography, { variant: 'body1', style: textStyle }, text)));
};
RenderRadioField.defaultProps = {
    value: true,
};
RenderRadioField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    onValueChange: prop_types_1.default.any.isRequired,
    text: prop_types_1.default.string.isRequired,
    value: prop_types_1.default.any,
    defaultValue: prop_types_1.default.bool,
    textStyle: prop_types_1.default.any,
};
exports.default = RenderRadioField;
